import { Component, OnDestroy } from '@angular/core';
import { Carousel } from "./carousel/carousel";
import { WhyUs } from "./why-us/why-us";
import { Pricing } from "./pricing/pricing";
import { Search } from "./search/search";
import { GetStarted } from "./get-started/get-started";
import { Milestones } from "./milestones/milestones";
import { Explore } from "./explore/explore";
import { PlayStore } from '../../shared/playstore/playstore';
import { CrossComponentService } from '../../core/services/cross-component.service';
import { HomePopup } from "../../shared/components/home-popup/home-popup";


@Component({
  selector: 'app-home',
  imports: [Carousel, WhyUs, Pricing, Search, GetStarted, Milestones, Explore, PlayStore, HomePopup],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home implements OnDestroy {
  private popupTimeoutId?: number;

  constructor(public crossComponentService: CrossComponentService) {
    const dismissedAt = Number(localStorage.getItem('homePopupDismissedAt') || '0');
    const cooldownMs = 24 * 60 * 60 * 1000;

    if (dismissedAt && Date.now() - dismissedAt < cooldownMs) {
      return;
    }

    this.popupTimeoutId = window.setTimeout(() => {
      this.crossComponentService.openHomePopup()
    }, 10000);
  }

  ngOnDestroy(): void {
    if (this.popupTimeoutId !== undefined) {
      clearTimeout(this.popupTimeoutId);
      this.popupTimeoutId = undefined;
    }
  }
}
